// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"ce84f104","288":"168b4ee7","333":"4e688c91","520":"d45085ba","895":"8c81a364"}[chunkId] + ".chunk.js";
};